import { apiInstance } from "shared/api";
import {
  ContractData,
  ApiContractsResponse,
  CheckSignContractBody,
  CheckSignContractsResponse,
  SignContractsResponse,
} from "./types";

export const getContracts = (): Promise<ApiContractsResponse> =>
  apiInstance.get("/v1/contracts").then((response) => response.data);

export const getContractById = (id: string): Promise<ContractData> =>
  apiInstance.get(`/v1/contracts/${id}`).then((response) => response.data);

export const signContractById = (
  id: string,
  params?: { provider: string },
): Promise<SignContractsResponse> =>
  apiInstance
    .post(`/v1/contracts/${id}/sign`, params)
    .then((response) => response.data);

export const checkSignContractById = (
  id: string,
  params: CheckSignContractBody,
): Promise<CheckSignContractsResponse> =>
  apiInstance
    .post(`/v1/contracts/${id}/sign-check`, params)
    .then((response) => response.data);

export const getContractPdfById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/contracts/${id}/download`, {
      responseType: "blob",
    })
    .then((response) => response.data);

export const downloadContractById = (id: string): Promise<Blob> =>
  apiInstance
    .get(`/v1/contracts/${id}/download-archive`, {
      responseType: "blob",
    })
    .then((response) => response.data);
